import Repository from '../axios'
import {defaultPagination} from "@/constants/config";

const resource = "/admin/inventory";
export default {
  getRmOrderList(pageNumber = 1, filterQuery, pagination = defaultPagination, sort, supplier_id = "") {
    return Repository.get(`${resource}/raw_material_orders?paginate=${pagination}&page=${pageNumber}&${filterQuery}&sort=${sort}&supplier_id=${supplier_id}`)
  },
  getRmOrderDetails(id) {
    return Repository.get(`${resource}/raw_material_orders/${id}`)
  },
  updateRmOrderDetails(id, payload) {
    return Repository.put(`${resource}/raw_material_orders/${id}`, payload)
  },
  updateRmOrderItems(id, payload) {
    return Repository.put(`${resource}/raw_material_order_item/${id}`, payload)
  },
  getListOfRmPrices(pageNumber = 1, filterQuery, pagination = defaultPagination) {
    return Repository.get(`${resource}/raw_material_catalogues?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  getRawMaterialPrice(id) {
    return Repository.get(`${resource}/raw_material_catalogues/${id}`)
  },
  getRmOutstandingOrders(id){
    return Repository.get(`${resource}/raw-material-orders/raw-materials/${id}/outstanding-orders`)
  },
  addRmToCart(payload) {
    return Repository.post(`${resource}/raw_material_carts`, payload)
  },
  getRmOrderCartList() {
    return Repository.get(`${resource}/raw_material_carts`)
  },
  removeRmFromCart(id) {
    return Repository.delete(`${resource}/raw_material_carts/${id}`)
  },
  createRmOrder(payload) {
    return Repository.post(`${resource}/raw_material_orders`, payload)
  },
  getRmOrderItemLabel(id) {
    return Repository.get(`${resource}/raw_material_order_item/${id}/pdf`)
  },
  changeRmOrderHandleType(id) {
    return Repository.put(`${resource}/raw_material_order/${id}/item_status_handle`)
  },

  getPredictedUseReportDetails(pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`${resource}/rm_use_report?paginate=${pagination}&page=${pageNumber}&${filterQuery}&sort=${sort}`)
  },
  rmOrdersStatusChange(id, status, payload = {}) {
    return Repository.put(`${resource}/raw_material_order/${id}/${status}`, payload)
  },
  rmOrdersItemStatusChange(id, payload ) {
    return Repository.put(`${resource}/raw_material_order_item/${id}/status`, payload)
  },

  createOrderItemQcTest(payload) {
    return Repository.post(`${resource}/r_m_order_item_q_c_tests`, payload)
  },
  getOrderItemQcTest(id) {
    return Repository.get(`${resource}/r_m_order_item_q_c_tests/${id}`)
  },
  updateOrderItemQcTest(id, payload) {
    return Repository.put(`${resource}/r_m_order_item_q_c_tests/${id}`, payload)
  },

  getSundryItemStockList(pageNumber = 1, filterQuery, pagination = defaultPagination) {
    return Repository.get(`${resource}/stock/sundry_stocks?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  getSundryItemStock(id) {
    return Repository.get(`${resource}/stock/sundry_stocks/${id}`)
  },
  getSundryItemAdjustLogSummary(from, to) {
    return Repository.get(`/admin/log/staff/inventory/sundry-item-inventory-change-summary?from=${from}&to=${to}`)
  },
  getSundryItemAuditLogSummary(date) {
    return Repository.get(`/admin/log/staff/inventory/sundry-item-inventory-summary?date=${date}`)
  },
  getSundryItemStockLog(id, pageNumber = 1, filterQuery, pagination = defaultPagination) {
    return Repository.get(`/admin/log/staff/inventory/sundry-item-inventory?sundry_item_id=${id}&paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  getProductStockList(pageNumber = 1, filterQuery, pagination = defaultPagination) {
    return Repository.get(`${resource}/stock/product_stocks?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  getRawMaterialStock(id) {
    return Repository.get(`${resource}/stock/raw_material_stocks/${id}`)
  },
  downloadProductStockSheet() {
    return Repository.get(`/admin/export/report/product-stock`, {
      responseType:'blob'
    })
  },
  downloadFGUsageSheet() {
    return Repository.get(`/admin/export/report/product-stock`, {
      responseType:'blob'
    })
  },
  downloadSundryStockSheet() {
    return Repository.get(`/admin/export/report/sundry-stock`, {
      responseType:'blob'
    })
  },
  getProductStockLog(id, pageNumber = 1, filterQuery, pagination = defaultPagination) {
    return Repository.get(`/admin/log/staff/inventory/formulation-inventory?formulation_id=${id}&paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  getProductAuditLogSummary(date) {
    return Repository.get(`/admin/log/staff/inventory/formulation-inventory-summary?date=${date}`)
  },
  getProductAdjustLogSummary(from, to) {
    return Repository.get(`/admin/log/staff/inventory/formulation-inventory-change-summary?from=${from}&to=${to}`)
  },

  updateCurrentStockLevel(id, payload) {
    return Repository.put(`${resource}/stock/raw_material_stocks/${id}`, payload)
  },
  updateFinishedProductCurrentStockLevel(id, payload) {
    return Repository.put(`${resource}/stock/product_stocks/${id}`, payload)
  },
  updateSundryItemCurrentStockLevel(id, payload) {
    return Repository.put(`${resource}/stock/sundry_stocks/${id}`, payload)
  },
  getRawMaterialStockLog(id, pageNumber = 1, filterQuery, pagination = defaultPagination) {
    return Repository.get(`/admin/log/staff/inventory/raw-material-inventory?raw_material_id=${id}&paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  getRawMaterialAuditLogSummary(date) {
    return Repository.get(`/admin/log/staff/inventory/raw-material-inventory-summary?date=${date}`)
  },
  getRawMaterialAdjustLogSummary(from, to) {
    return Repository.get(`/admin/log/staff/inventory/raw-material-inventory-change-summary?from=${from}&to=${to}`)
  },

  getRmOrderPoPdfDetails(id) {
    return Repository.get(`${resource}/raw_material_order/${id}/purchase_order_pdf?timezone=Europe/London`)
  },
  sendRmOrderPoPdf(id, payload) {
    return Repository.post(`${resource}/raw_material_order/${id}/send_order_confirmation_pdf`, payload)
  },
  getRmOrderPoPdfPublic(secret_code) {
    return Repository.get(`${resource}/raw_material_order/${secret_code}/pdf_data`)
  },
  getRmOrderInvoiceEmailLog(id) {
    return Repository.get(`${resource}/raw_material_order/${id}/sent-email-logs`)
  },

  //INVENTORY FILE UPLOAD
  updateInventoryFilePaths(id, payload){
    return Repository.put(`/admin/manufacture/raw-material-inventory/${id}/file-paths`, payload)
  },
  getRawMaterialInventoryFilePath(id){
    return Repository.get(`/admin/manufacture/raw-material-inventory/${id}/file-paths`)
  },
  toggleRawMaterialStockOpened(id, payload) {
    return Repository.put(`/admin/manufacture/raw-material-inventory/${id}/opened`, payload)
  },

  // RM WASTE ITEMS
  getRawMaterialWasteItemList(pageNumber = 1, filterQuery, pagination = defaultPagination) {
    return Repository.get(`/admin/manufacture/raw_material_wastes?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  updateRawMaterialWaste(id, payload) {
    return Repository.put(`/admin/manufacture/raw_material_wastes/${id}`, payload)
  },
  removeRawMaterialWaste(payload) {
    return Repository.delete(`/admin/manufacture/raw_material_waste_items`, {data : payload})
  },
  createRawMaterialWaste(payload) {
    return Repository.post(`/admin/manufacture/raw_material_waste_items`, payload)
  },
  getRawMaterialWaste(id) {
    return Repository.get(`/admin/manufacture/raw_material_wastes/${id}`)
  },
  getRawMaterialWasteItemListByFormulationId(formulation_id, pageNumber = 1, filterQuery, pagination = defaultPagination) {
    return Repository.get(`/admin/manufacture/raw_material_waste/list_by_formulation?formulation_id=${formulation_id}&paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  getRmWasteItem(wo, rm, pageNumber = 1, pagination = defaultPagination) {
    return Repository.get(`/admin/manufacture/raw_material_waste/list_by_wormid?paginate=${pagination}&&page=${pageNumber}&filter[work_order]=${wo}&filter[rm]=${rm}&filter[status]=In Stock`)
  },
  disposeRawMaterialWasteItem(id, payload) {
    return Repository.put(`/admin/manufacture/raw_material_waste/${id}/dispose`, payload)
  },
  sendWasteItemToStock(id, payload) {
    return Repository.post(`admin/manufacture/raw-material-inventory/${id}/add-to-stock`, payload)
  },

  //PRODUCT WASTE
  getProductOrderWasteList(pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`${resource}/product_wastes?paginate=${pagination}&page=${pageNumber}&${filterQuery}&sort=${sort}`)
  },
  createProductWaste(payload) {
    return Repository.post(`${resource}/product_wastes`, payload)
  },
  disposeProductWasteItem(id, payload) {
    return Repository.put(`${resource}/product_waste/${id}/disposed`, payload)
  },
  rawMaterialOrderChangeStatus(id, status){
    return Repository.put(`${resource}/raw_material_order/${id}/${status}`)
  },
  createRawMaterialOrderDocument(id, payload){
    return Repository.post(`${resource}/raw_material_orders/${id}/documents`,payload)
  },
  getRawMaterialOrderDocument(id){
    return Repository.get(`${resource}/raw_material_orders/${id}/documents`)
  },

  //PRODUCT RETURN STOCK
  createReturnProductStock(payload){
    return Repository.post(`${resource}/return-inventories`,payload)
  },
  createReturnStockQcTest(inventory_id, payload) {
    return Repository.post(`${resource}/return-inventory/${inventory_id}/q-c-test`, payload)
  },
  returnStockQcTestNotRequired(inventory_id) {
    return Repository.put(`${resource}/return-inventory/${inventory_id}/qc-not-required`)
  },
  getListOfProductReturnStock(pageNumber = 1, filterQuery, pagination = defaultPagination) {
    return Repository.get(`${resource}/return-inventories?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },

  //SUNDRY WASTE ITEMS
  getSundryItemWasteItemList(pageNumber = 1, filterQuery, pagination = defaultPagination) {
    return Repository.get(`${resource}/sundry-wastes?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  disposeSundryItemWasteItem(id, payload) {
    return Repository.put(`${resource}/sundry-waste/${id}/disposed`, payload)
  },

  //ORDER ITEMS PAYMENT STATUS CHANGE
  rmOrderItemPaymentStatusChange(item_id, payment_status) {
    return Repository.put(`/admin/inventory/raw_material_order_item/${item_id}/payment-status`, { status: payment_status })
  },
  sundryOrderItemPaymentStatusChange(item_id, payment_status) {
    return Repository.put(`/admin/supplier/sundry-item-order-item/${item_id}/payment-status`, { status: payment_status })
  },
  otherOrderItemPaymentStatusChange(item_id, payment_status) {
    return Repository.put(`/admin/supplier/other-supplier-order-item/${item_id}/payment-status`, { status: payment_status })
  },

  //RM ITEM BATCH
  updateRamItemBatchDetails(id, payload) {
    return Repository.put(`${resource}/raw-material-order-item/batch/${id}`, payload)
  },
  rmOrderItemBatchPaymentStatusChange(batch_id, payment_status) {
    return Repository.put(`${resource}/raw-material-order-item/batch/${batch_id}/payment-status`, { status: payment_status })
  },

  //LOW/SLOW STOCK REPORT
  getLowStockReportDetails(pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`/admin/report/rm-low-stock-report?paginate=${pagination}&page=${pageNumber}&${filterQuery}&sort=${sort}`)
  },
  getRmItemsSlowStockReportDetails(pageNumber = 1, filterQuery, pagination = defaultPagination) {
    return Repository.get(`/admin/report/rm-slow-stock-report?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  getRmItemsConsumptionReportDetails(pageNumber = 1, filterQuery, pagination = defaultPagination) {
    return Repository.get(`/admin/report/raw-material-consumption-report?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  getRmOrderByItemsList(pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`${resource}/raw-material-order-items?paginate=${pagination}&page=${pageNumber}&${filterQuery}&sort=${sort}`)
  },
  getListOfItemsConfirmedToWorkOrder(pageNumber = 1, pagination = defaultPagination, item_type, item_id){
    return Repository.get(`/admin/manufacture/work-orders/item-usages?paginate=${pagination}&page=${pageNumber}&item_type=${item_type}&item_id=${item_id}`)
  },
};
